(function (root, factory) {
  const engine = factory();
  if (typeof module === 'object' && module.exports) module.exports = engine;
  else root.PrismEntries = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const id = (value) => String(value).split('/').pop();
  const parse = (value) => typeof value === 'string' ? JSON.parse(value || '{}') : value || {};

  function calculate(cart, campaign, plan = 1, now = Date.now()) {
    if (!campaign || campaign.isActive === false) throw new Error('Campaign unavailable');
    const start = number(campaign.startDate, NaN);
    const end = number(campaign.endDate, NaN);
    if ((Number.isFinite(start) && start > now) || (Number.isFinite(end) && end <= now)) throw new Error('Campaign unavailable');
    const management = parse(campaign.entryManagement);
    const dollars = number(management.dollarSpent);
    if (dollars <= 0) throw new Error('Invalid entry rate');
    const round = management.roundUp === false ? (v) => Math.floor(v + 1e-9) : (v) => Math.ceil(v - 1e-9);
    const baseRate = Math.max(1, number(management.entryPer, 1));
    const scheduled = number(campaign.scheduledBonusValue);
    const rate = campaign.scheduledBonusActive === true && scheduled >= 1 ? scheduled : baseRate;
    const rules = new Map((campaign.products || []).map((rule) => [id(rule.productId), rule]));
    let weightedDollars = 0;
    let eligibleCents = 0;
    let productBonus = 0;
    let orderMultiplier = 1;
    const lines = (cart.items || []).map((line, index) => {
      const quantity = Math.max(0, number(line.quantity));
      const original = number(line.original_line_price, number(line.original_price ?? line.price) * quantity);
      const effective = campaign.calculateWithDiscount
        ? number(line.final_line_price, original - number(line.total_discount)) : original;
      const rule = rules.get(id(line.product_id));
      const eligible = rule ? rule.productAllowed === true : campaign.productsAllowedByDefault === true;
      const multiplier = campaign.membershipProductMultOverride ? 1
        : rule && number(plan) >= 3 ? Math.max(1, number(rule.productMultiplier, 1)) : 1;
      if (rule?.orderMultiplierAllowed && number(plan) >= 3) orderMultiplier = Math.max(orderMultiplier, number(rule.orderMultiplier, 1));
      const weighted = eligible ? round(Math.max(0, effective) / 100) * multiplier : 0;
      const bonus = eligible ? number(rule ? rule.productBonusEntries : campaign.bonusEntriesDefault) * quantity : 0;
      const base = round((rate / dollars) * weighted);
      weightedDollars += weighted;
      eligibleCents += eligible ? Math.max(0, effective) : 0;
      productBonus += bonus;
      return { key: line.key || String(index), productId: id(line.product_id), eligible, quantity, multiplier, base, bonus, entries: base + bonus };
    });
    const baseEntries = round((rate / dollars) * weightedDollars);
    const originalCents = number(cart.original_total_price, (cart.items || []).reduce((sum, line) => sum + number(line.original_line_price, number(line.original_price ?? line.price) * number(line.quantity)), 0));
    const thresholdCents = campaign.bonusSpendingEnabledProductOnly ? eligibleCents
      : campaign.calculateWithDiscount ? number(cart.total_price, originalCents) : originalCents;
    const thresholds = (management.bonusSpending || []).filter((v) => v.spendingLimitEnabled === true)
      .map((v) => ({ cents: Math.round(number(v.spendingLimitDollar) * 100), entries: number(v.bonusEntries) }))
      .filter((v) => v.cents >= 0 && v.entries >= 0).sort((a, b) => a.cents - b.cents)
      .map((v) => ({ ...v, reached: thresholdCents >= v.cents }));
    const spendingBonus = thresholds.reduce((sum, v) => sum + (v.reached ? v.entries : 0), 0);
    const productEntries = baseEntries + productBonus;
    const roundingAdjustment = productEntries - lines.reduce((sum, line) => sum + line.entries, 0);
    return { lines, rate, dollars, productEntries, productBonus, baseEntries, spendingBonus, orderMultiplier, roundingAdjustment,
      total: (productEntries + spendingBonus) * orderMultiplier, thresholdCents, thresholds,
      nextThreshold: thresholds.find((v) => !v.reached) || null,
      thresholdBasis: campaign.bonusSpendingEnabledProductOnly ? 'eligible' : campaign.calculateWithDiscount ? 'discounted' : 'original' };
  }

  function withProduct(cart, product) {
    const items = (cart.items || []).map((line) => ({ ...line }));
    const existing = items.find((line) => String(line.variant_id) === String(product.variantId) && !line.selling_plan_allocation && !Object.keys(line.properties || {}).length);
    if (existing) {
      existing.original_line_price = number(existing.original_line_price, number(existing.price) * existing.quantity) + product.price;
      existing.final_line_price = number(existing.final_line_price, number(existing.price) * existing.quantity) + product.price;
      existing.quantity += 1;
    } else items.push({ key: 'preview-' + product.variantId, product_id: product.id, variant_id: product.variantId,
      quantity: 1, price: product.price, original_line_price: product.price, final_line_price: product.price });
    return { ...cart, items, original_total_price: number(cart.original_total_price) + product.price, total_price: number(cart.total_price) + product.price };
  }

  return { calculate, withProduct, id };
});
